import {
  Action,
  ActionType,
  UpdateReleaseDateResponse,
} from "models/userListBusiness/updateReleaseDate";

import createReducer from "../../createReducer";

export interface UpdateReleaseDateReducerType {
  loading: boolean;
  error?: string;
  updateReleaseDateResponse?: UpdateReleaseDateResponse;
}

const defaultState: UpdateReleaseDateReducerType = {
  loading: false,
  error: undefined,
  updateReleaseDateResponse: undefined,
};

export const updateReleaseDateReducer =
  createReducer<UpdateReleaseDateReducerType>(defaultState, {
    [ActionType.UPDATE_RELEASE_DATE](state: UpdateReleaseDateReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.UPDATE_RELEASE_DATE_ERROR](
      state: UpdateReleaseDateReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.UPDATE_RELEASE_DATE_SUCCESS](
      state: UpdateReleaseDateReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        updateReleaseDateResponse: action.payload,
      };
    },

    [ActionType.UPDATE_RELEASE_DATE_RESET](
      state: UpdateReleaseDateReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        updateReleaseDateResponse: undefined,
      };
    },
  });
